<document-lines-editor
  #lineGrid
  [columnDefs]="columnDefs"
  [rows]="lines"
  [treeData]="false"
  [isDialogBox]="true"
>
</document-lines-editor>
